import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import { currentAccountIdAtom } from "../account";
import { Member } from "../types";

export const ownerAtomFamily_SUSPENDS = atomFamily(
  (customuser_id: number | null) => {
    const ownerAtom = atom<Promise<Member | null>>(async (get) => {
      const currentAccountId = get(currentAccountIdAtom);
      // When an unauthenticated user is viewing a canvas, we don't have a currentAccountId
      if (!currentAccountId || !customuser_id) {
        return null;
      }
      const res = await fetch(
        `/api/v4/accounts/${currentAccountId}/members/${customuser_id}`,
      );
      return await res.json();
    });

    ownerAtom.debugLabel = `ownerAtomFamily_SUSPENDS(${customuser_id})`;
    return ownerAtom;
  },
);
